import { render } from "./PackagesManagerOrdersGeneratorPricingList1D.vue?vue&type=template&id=4c7d8b0c&scoped=true"
import script from "./PackagesManagerOrdersGeneratorPricingList1D.vue?vue&type=script&lang=js"
export * from "./PackagesManagerOrdersGeneratorPricingList1D.vue?vue&type=script&lang=js"

import "./PackagesManagerOrdersGeneratorPricingList1D.vue?vue&type=style&index=0&id=4c7d8b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7d8b0c"]])

export default __exports__